// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/82bb6b73b40193b7dd72.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"7eb07c25017e8a26178a","171":"f665edd0e0177ea43483","172":"06b70679900e75c8adb5"}[chunkId] + ".chunk.js";
};